export default "__VITE_ASSET__DXdfvizz__"